import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ReactiveFormsModule} from '@angular/forms';
import {TranslateModule} from '@ngx-translate/core';
import {NgxPermissionsModule} from 'ngx-permissions';
import {QuillModule} from 'ngx-quill';
import {
  BzDialogLayout,
  BzFormField,
  BzInput,
  BzProgress,
  BzSpinner,
  BzTable,
  BzTableHeaderDef,
  BzTableRowDef,
  BzTag
} from '@bringoz/ui';
import {CommonsModule} from '../../commons/angular/commons.module';
import {TermsViewComponent} from './components/terms-view/terms-view.component';
import {TermsEditorDialogComponent} from './components/terms-editor-dialog/terms-editor-dialog.component';
import {TermsApprovalsPanelComponent} from './components/terms-approvals-panel/terms-approvals-panel.component';

/**
 * Imported by AppModule rather than bootstrapped on its own: TermsViewComponent is downgraded
 * into the AngularJS router through downgradedAppModule, so it has to share that injector.
 */
@NgModule({
  declarations: [
    TermsViewComponent,
    TermsEditorDialogComponent,
    TermsApprovalsPanelComponent
  ],
  imports: [
    CommonModule,
    CommonsModule,
    ReactiveFormsModule,
    TranslateModule.forChild(),
    NgxPermissionsModule.forChild(),
    // sanitize: HTML loaded into the editor goes through Angular's sanitizer first.
    QuillModule.forRoot({sanitize: true}),
    BzTable,
    BzTableHeaderDef,
    BzTableRowDef,
    BzTag,
    BzDialogLayout,
    BzFormField,
    BzInput,
    BzSpinner,
    BzProgress
  ],
  exports: [
    TermsViewComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class TermsModule {
}
